import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Alert } from '@mui/material';
import { blockUserService } from '../../services/blockUserService';

const BlockUserTest = () => {
  const [userId, setUserId] = useState('');
  const [reason, setReason] = useState('Test block');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const testBlock = async () => {
    if (!userId.trim()) return;
    
    setLoading(true);
    try {
      console.log('🧪 Testing block user with ID:', userId);
      const result = await blockUserService.blockUser(userId, reason);
      setResult({ type: 'block', success: true, data: result });
    } catch (error) {
      setResult({ type: 'block', success: false, error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const testGetBlocked = async () => {
    setLoading(true);
    try {
      console.log('🧪 Testing get blocked users');
      const result = await blockUserService.getBlockedUsers(10);
      setResult({ type: 'get', success: true, data: result });
    } catch (error) {
      setResult({ type: 'get', success: false, error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const testUnblock = async () => {
    if (!userId.trim()) return;
    
    setLoading(true);
    try {
      console.log('🧪 Testing unblock user with ID:', userId);
      const result = await blockUserService.unblockUser(userId);
      setResult({ type: 'unblock', success: true, data: result });
    } catch (error) {
      setResult({ type: 'unblock', success: false, error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 3, m: 2 }}>
      <Typography variant="h6" gutterBottom>Block User Test</Typography>
      
      <Box sx={{ mb: 2 }}>
        <TextField
          fullWidth
          label="User ID to Block/Unblock"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          sx={{ mb: 2 }}
        />
      </Box>

      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
        <Button 
          variant="contained" 
          color="error"
          onClick={testBlock} 
          disabled={loading || !userId.trim()}
        >
          Test Block
        </Button>
        <Button 
          variant="contained" 
          color="success"
          onClick={testUnblock} 
          disabled={loading || !userId.trim()}
        >
          Test Unblock
        </Button>
        <Button 
          variant="outlined"
          onClick={testGetBlocked} 
          disabled={loading}
        >
          Get Blocked Users
        </Button>
      </Box>

      {result && (
        <Alert severity={result.success ? 'success' : 'error'} sx={{ mt: 2 }}>
          <Typography variant="subtitle2">
            {result.type.toUpperCase()} Result:
          </Typography>
          <pre style={{ fontSize: '12px', marginTop: '8px' }}>
            {JSON.stringify(result.success ? result.data : result.error, null, 2)}
          </pre>
        </Alert>
      )}
    </Paper>
  );
};

export default BlockUserTest;